import { Box } from "@mui/material";
import * as React from "react";

export interface Props {
  children: React.ReactNode;
}

export const BasicLayout = ({ children }: Props) => {
  // Shared "main-page-layout" id: the Playwright snapshotMainPageLayout helper
  // asserts this id is visible on every page regardless of which layout renders.
  return <Box data-test-id="main-page-layout">{children}</Box>;
};
